'use strict';

const _=require('pulsar-utils/dist-es6/_');
const NonReentrantCommand=require('../../../dist-es6/client/angularCommon/nonReentrantCommand');
const ModalSubmissionResult=require('../../../dist-es6/client/angularCommon/modalSubmissionResult');let

ModalSubmissionCommand=class ModalSubmissionCommand{
constructor(modalInstance,submissionAction,$timeout,rx){
this._modalInstance=modalInstance;
this._submissionAction=submissionAction;
this._completed=!1;
this._nonReentrantCommand=new NonReentrantCommand(this._doIt.bind(this),$timeout,rx);
this._execute=this._nonReentrantCommand.execute.bind(this._nonReentrantCommand);
}

async _doIt(){
if(this._completed){
return;
}

let submissionResult=await this._submissionAction();
_.ensureInstanceOf(ModalSubmissionResult,submissionResult);

if(submissionResult.type==='KeepOpen'){
return;
}

this._completed=!0;

switch(submissionResult.type){
case'Abandon':
break;

case'Close':
this._modalInstance.close(submissionResult.result);
break;

case'Dismiss':
this._modalInstance.dismiss(submissionResult.reason);
break;

default:
throw new Error('bad ModalSubmissionResult type');}


}

get execute(){
return this._execute;
}

get inProgress(){
return this._nonReentrantCommand.inProgress;
}

get completed(){
return this._completed;
}};


module.exports=ModalSubmissionCommand;
//# sourceMappingURL=modalSubmissionCommand.js.map
